import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function TargetAudienceSection() {
  const points = ['Querés aprender electricidad básica', 'Querés resolver cosas de tu casa', 'Querés dejar de depender de alguien', 'Querés ahorrar dinero en arreglos', 'Te gusta aprender cosas nuevas', 'Querés sentirte más independiente', 'Querés saber cómo funciona la electricidad de tu casa'];
  return <section className="py-0 bg-brand-50 px-4" data-id="element-233">
      <div className="max-w-4xl mx-auto" data-id="element-234">
        <motion.div className="bg-white rounded-[2.5rem] p-8 md:p-14 border border-brand-100 shadow-xl shadow-brand-100/50 relative overflow-hidden" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-235">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-bl from-brand-100/50 to-transparent rounded-bl-full opacity-50" data-id="element-236" />

          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-12 text-center text-gray-900 relative z-10" data-id="element-237">
            🏠 Este Mega Pack es para vos si:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 relative z-10" data-id="element-238">
            {points.map((point, index) => <motion.div key={index} className="flex items-start gap-4" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-239">
                <div className="bg-green-50 rounded-full p-1 flex-shrink-0 mt-0.5" data-id="element-240">
                  <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-241" />
                </div>
                <span className="text-lg text-gray-700 font-medium" data-id="element-242">
                  {point}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}